export default (preselectedItems, display, exploder) => ({

    value: '',
    items: [],
    preselectedItems: preselectedItems,
    exploder: exploder,
    display: display,
    showExploder: false,

    init() {
        if (this.preselectedItems) {
            this.setItems(this.preselectedItems);
        }
    },

    get placeholder() {
        let placeholder = this.display;
        if (this.exploder) {
            placeholder = placeholder + ' (separate multiple items with ' + (this.exploder === ' ' ? 'a space' : this.exploder) + ')';
        }

        return placeholder;
    },

    addItem() {
        if (this.value) {

            if (this.exploder && this.value.includes(this.exploder)) {
                this.value.split(this.exploder).filter(item => item).forEach(element => this.items.push(element));
            } else {
                this.items.push(this.value);
            }

            this.value = '';
            this.focusOnValue();
        }
    },

    removeItem(key) {
        this.items = this.items.filter((item, index) => index !== key);
        this.focusOnValue();
    },

    setItems(items) {
        if (Array.isArray(items)) {
            this.items = items;
        }
    },

    focusOnValue() {
        this.$refs.valueRef.focus();
    },

    toggleExploder() {
        this.showExploder = !this.showExploder;

        this.$nextTick(() => {
            if (this.showExploder) {
                this.$refs.exploderRef.focus();
            } else {
                this.$refs.valueRef.focus();
            }
        });
    },
});
